(() => {
  if (window.olivarteStickyBound) return;
  window.olivarteStickyBound = true;
  const barSelector = '.enhanced-sticky-bar';
  const mainQuantity = (form) => [...form.elements].find(input => input.name === 'quantity' && !input.closest(barSelector));
  const bars = (form) => [...document.querySelectorAll(barSelector)].filter(bar => bar.getAttribute('form') === form.getAttribute('id'));
  const sync = (form, value, notify = false) => {
    const main = mainQuantity(form);
    if (!main) return;
    const min = Number(main.min) || 1;
    const step = Number(main.step) || 1;
    const max = main.max ? Number(main.max) : Infinity;
    const number = Number.parseInt(value, 10);
    const qty = Math.min(max, min + Math.max(0, Math.round(((Number.isFinite(number) ? number : min) - min) / step)) * step);
    main.value = String(qty);
    bars(form).forEach(bar => bar.querySelectorAll('.sticky-quantity-input').forEach(input => {
      input.value = String(qty); input.min = String(min); input.step = String(step);
      if (Number.isFinite(max)) input.max = String(max); else input.removeAttribute('max');
    }));
    if (notify) main.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('click', event => {
    const button = event.target.closest(`${barSelector} .quantity-button`);
    if (!button) return;
    const form = document.getElementById(button.closest(barSelector).getAttribute('form'));
    if (!form) return;
    const input = mainQuantity(form);
    if (!input) return;
    event.preventDefault();
    sync(form, Number(input.value) + (button.classList.contains('quantity-minus') ? -1 : 1) * (Number(input.step) || 1), true);
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('input')) return;
    const bar = input.closest(barSelector);
    const form = bar ? document.getElementById(bar.getAttribute('form')) : input.form;
    if (!form || !bars(form).length) return;
    if (input.matches('.sticky-quantity-input')) sync(form, input.value, true);
    else if (input.name === 'quantity') sync(form, input.value);
  });
  const refresh = () => document.querySelectorAll(barSelector).forEach(bar => {
    const form = document.getElementById(bar.getAttribute('form'));
    if (form) sync(form, mainQuantity(form)?.value || 1);
  });
  document.addEventListener('variant:change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
